
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/drill/[topicId]",
      function () {
        return require("private-next-pages/drill/[topicId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/drill/[topicId]"])
      });
    }
  